import { everest } from '~/services/serviceInstances';

import { ShareSettingsPayload } from './types';
import { computeVisibility } from './utils';

const transformShareSettings = (
  response: ShareSettingsPayload,
  currentUserId: number,
) => {
  const userIds = response.data.attributes.user_ids;
  const departmentIds = response.data.attributes.department_ids;

  return {
    hasSettings: true,
    visibility: computeVisibility(userIds, departmentIds, currentUserId),
    userIds,
    departmentIds,
  };
};

const getDefaultData = () => {
  return {
    hasSettings: false,
    visibility: 'OPEN',
    userIds: [],
    departmentIds: [],
  };
};

export const getWorkflowShareSettings = async ({
  workflowId,
  currentUserId,
}: {
  workflowId: string;
  currentUserId: number;
}) => {
  try {
    const response = await everest.get(
      `/workflows/${workflowId}/visibility-settings/`,
    );
    return transformShareSettings(response, currentUserId);
  } catch (e: any) {
    if (e?.response?.status === 404) {
      // if the share setting doesn't exist yet, it's public/open
      return getDefaultData();
    }
    throw e;
  }
};
